import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ClientPreview } from '../clients.models';
import { Router } from '@angular/router';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCell, MatCellDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { BoolToImgPipe } from '../../_infrastructure/pipes';
import { DatePipe } from '@angular/common';
import { env } from '../../../env/env';

@Component({
  selector: 'app-clients',
  templateUrl: './clients-list.component.html',
  styleUrls: ['./clients-list.component.css'],
  imports: [
    MatInput,
    MatFormField,
    FormsModule,
    MatButton,
    MatTableModule,
    MatRow,
    MatHeaderRow,
    MatHeaderCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatCellDef,
    MatHeaderCellDef,
    MatCell,
    MatHeaderCell,
    BoolToImgPipe,
    DatePipe
  ]
})
export class ClientsListComponent implements OnInit, AfterViewInit {

  constructor(private httpClient: HttpClient, private router: Router, private cd: ChangeDetectorRef) {
    this.searchCriteria = '';
  }

  @ViewChild('filtersRef') filtersRef!: ElementRef<HTMLDivElement>;
  @ViewChild('pageRef') pageRef!: ElementRef<HTMLDivElement>;

  public tableContainerHeight: string = '0px';

  ngOnInit() {
    this.loadClients();
  }

  ngAfterViewInit() {
    this.updateTableHeight();
    window.addEventListener('resize', () => this.updateTableHeight());
  }

  private updateTableHeight() {
    const pageTop = this.pageRef.nativeElement.getBoundingClientRect().top;
    const filtersHeight = this.filtersRef.nativeElement.offsetHeight;
    this.tableContainerHeight = `calc(100vh - ${pageTop}px - ${filtersHeight}px - 10px)`;
    this.cd.detectChanges();
  }

  public searchCriteria: string;

  public clients: MatTableDataSource<ClientPreview> = new MatTableDataSource<ClientPreview>;

  private loadClients() {
    this.httpClient.get(env.apiUrl + `/clients?q=${this.searchCriteria}`).subscribe({
      next: s => {
        this.clients.data = s as ClientPreview[];
      }
    });
  }

  public searchClients() {
    this.loadClients();
  }

  public selectClient(client: ClientPreview): void {
    this.router.navigate(['clients', client.id]);
  }

}
